import { render, staticRenderFns } from "./IndexOld.vue?vue&type=template&id=573ff000&"
import script from "./IndexOld.vue?vue&type=script&lang=js&"
export * from "./IndexOld.vue?vue&type=script&lang=js&"
import style0 from "./IndexOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports